import React, { useEffect } from 'react';
import { useKeycloak } from '@react-keycloak/web';
import { useUnit } from 'effector-react';
import useUserProfile from 'hooks/useKeycloakUser';
import { useLocation, useNavigate } from 'react-router-dom';
import { $user } from 'models/user';
import { Button } from '@/components/ui/Button';

const normalizeRef = (value: string | null) => {
  if (!value || !value.startsWith('/') || value.startsWith('//')) return '/section';
  return value;
};

const Login: React.FC = () => {
  const { keycloak } = useKeycloak();
  const user = useUnit($user);
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const ref = normalizeRef(queryParams.get('ref'));

  useUserProfile();

  useEffect(() => {
    if (keycloak.authenticated && user) {
      navigate(ref, { replace: true });
    }
  }, [keycloak.authenticated, navigate, ref, user]);

  return (
    <>
      {!keycloak.authenticated ? (
        <div className="flex min-h-screen flex-col items-center justify-center bg-gradient-to-br from-blue-100 to-purple-200 p-4">
          <div className="bg-white rounded-lg shadow-lg p-8 w-full max-w-md">
            <h2 className="text-2xl font-bold mb-6 text-center text-gray-800">Вход в систему</h2>
            <Button fullWidth size="lg" onClick={() => keycloak.login()}>
              Войти через Keycloak
            </Button>
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default Login;
